import { Injectable } from '@angular/core';
import { IPersistenceContainer, PersistenceService, StorageType } from 'angular-persistence';
import { CustomerInfo, WishListItem, Dealer, ConfigurationInfo } from '../models';

@Injectable()
export class DataStorageService {

    private container: IPersistenceContainer;
    private CustomerInfoKey = 'CustomerInfoKey';
    private WishListKey = 'WishListKey';
    private DealersListKey = 'DealersListKey';
    private DealerKey = 'DealerKey';
    private ConfigurationKey = 'ConfigurationKey';

    constructor(persistenceService: PersistenceService) {

        this.container = persistenceService.createContainer(
            'org.wheretobuy',
            { type: StorageType.SESSION, oneUse: false }
        );
    }

    public getCustomerInfo(): CustomerInfo {
        return this.container.get(this.CustomerInfoKey);
    }

    public setCustomerInfo(info: CustomerInfo) {
        this.container.set(this.CustomerInfoKey, info);
    }

    public setDealersList(dealers: Dealer[]) {
        this.container.set(this.DealersListKey, dealers);
    }

    public getDealersList(): Dealer[] {
        return this.container.get(this.DealersListKey);
    }

    public setDealer(dealer: Dealer) {
        this.container.set(this.DealerKey, dealer);
    }

    public getDealer(): Dealer {
        return this.container.get(this.DealerKey);
    }

    public getConfiguration(): ConfigurationInfo {
        return this.container.get(this.ConfigurationKey);
    }

    public setConfiguration(configuration: ConfigurationInfo) {
        this.container.set(this.ConfigurationKey, configuration);
    }

    public isRefresh(): boolean {

        return this.checkParam('refresh');
    }

    public isOnlyRsc55(): boolean {

        return this.checkParam('onlyRsc55');
    }

    public isOnlyWorkwear(): boolean {

        return this.checkParam('onlyWorkwear');
    }

    private checkParam(name: string): boolean {

        const params = this.parseQuery(window.location.search);

        const refresh = params[name] as string;

        if (refresh == null) { return false; }

        if (refresh.toLowerCase() === 'true') { return true; }

        return false;
    }

    /*
    public getStoredWishList(): WishListItem[] {
        return this.container.get(this.WishListKey);
    }

    public setStoredWishList(WishList)

    private parseWishListInQueryString(): void {
        const query = this.parseQuery(window.location.search);
        const res = new Array<WishListItem>();
        // Code1;Descr1;Qty1|Code2;Descr2;Qty2|Code3;Descr3;Qty3
        const wishList = query.wishList;
        if (wishList == null) {
            this.container.set(this.WishListKey, []);
            return;
        }
        const items = wishList.split('|');
        for (const tuple of items) {
            const fields = tuple.split(';');

            if (fields.length !== 3) {
                console.warn('Skipping wish list item: ' + tuple);
                continue;
            }

            res.push({
                code: fields[0],
                description: fields[1],
                quantity: fields[2]
            });
        }
        console.log(res);
        this.container.set(this.WishListKey, res);
    }
    */
    private parseQuery(queryString): any {
        const query = {};
        const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (let i = 0; i < pairs.length; i++) {
            const pair = pairs[i].split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return query;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/data-storage.service.ts